import { render, staticRenderFns } from "./TransmissionOfShares.vue?vue&type=template&id=387a3471&scoped=true&"
import script from "./TransmissionOfShares.vue?vue&type=script&lang=js&"
export * from "./TransmissionOfShares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387a3471",
  null
  
)

export default component.exports